module.exports = __webpack_public_path__ + "img/area-part4-232.f6237125.png";